import * as React from 'react';
import Svg, { SvgProps, Defs, Circle, G, Mask, Use, Path } from 'react-native-svg';

function SvgComponent(props: SvgProps) {
  return (
    <Svg width={29} height={29} {...props}>
      <Defs>
        <Circle id="prefix__a" cx={14.5} cy={14.5} r={14.5} />
      </Defs>
      <G fill="none" fillRule="evenodd" opacity={0.801}>
        <Mask id="prefix__b" fill="#fff">
          <Use xlinkHref="#prefix__a" />
        </Mask>
        <Use fill="#3D3D3D" xlinkHref="#prefix__a" />
        <Path
          d="M14.5 17c5.523 0 10.036 3.919 10.036 8.06 0 0-3.505 3.94-10.036 3.94S4.432 25.042 4.432 24.833C4.432 20.691 8.977 17 14.5 17zm0-12a6 6 0 110 12 6 6 0 010-12z"
          fill="#FFF"
          mask="url(#prefix__b)"
        />
      </G>
    </Svg>
  );
}

const UserIcon = React.memo(SvgComponent);
export default UserIcon;
